

import axios from 'axios';
import { postcodeValidator, postcodeValidatorExistsForCountry } from 'postcode-validator';
const API_KEY = process.env.REACT_APP_GMAP_API || process.env.REACT_APP_G_MAP_API_KEY;

export const getPostalCode = async (selectedFactory, address) => {
  // console.log("--adress--- :",address)
  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${API_KEY}`;

  try {
    const response = await axios.get(url);
    const results = response.data.results;
    let postalCode = null;
    if (results && results.length > 0) {
      const addressComponents = results[0].address_components;
      // console.log("address components: ",addressComponents)
      postalCode = addressComponents.find(component => component.types.includes('postal_code'));
      // console.log("postal code: ",postalCode)
    }
    return postalCode ? postalCode.long_name : null;
  } catch (error) {
    console.error('Error fetching postal code:', error);
  }
};

const isValidPostalString =(str) =>{
    const alphanumericPattern = /^[a-zA-Z0-9]+$/;
    return alphanumericPattern.test(str) && str.length > 3;
}

const isValidBDPostal = (str) => {
  const numericPattern = /^[0-9]{4}$/;
  return numericPattern.test(str);
}

const isValidVNPostal =(str) =>{
  const alphanumericPattern = /^[a-zA-Z0-9]+$/;
  return alphanumericPattern.test(str) && str.length === 5;
}

const isValidKHPostal = (str) => {
  const numericPattern = /^[0-9]{5,6}$/;
  return numericPattern.test(str);
}

export const isValidPostalCode = async (postalCode, countryCode) => {
  if (!postalCode || !countryCode) return false;

  if(countryCode === "BD"){
    return isValidBDPostal(postalCode);
  }
  if(countryCode === "VN"){
    return isValidVNPostal(postalCode);
  }
  if(countryCode === "KH"){
    return isValidKHPostal(postalCode);
  }

  const normalizedCountry = countryCode.toUpperCase();

  // 1. Local Library Validation (Fastest)
  if (postcodeValidatorExistsForCountry(normalizedCountry)) {
    const isValid = postcodeValidator(postalCode, normalizedCountry);
    if (isValid) return true;
    // If the library says it's invalid, we still double-check with Google 
    // in case the library is outdated.
  }

  // 2. Google Geocoding with Strict Component Filtering
  try {
    // IMPORTANT: Adding 'components=country' is the key to accuracy
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(postalCode)}&components=country:${normalizedCountry}&key=${API_KEY}`;
    
    const response = await axios.get(url);
    const results = response.data.results;
    // console.log("---google api result----",results)
    if (results && results.length > 0) {
      const topResult = results[0];

      // Check if the result actually represents a postal code
      const isPostalType = topResult.types.some(t => 
        ['postal_code', 'postal_code_prefix'].includes(t)
      );

      // Verify the country in the response matches your target
      const countryMatch = topResult.address_components.find(
        c => c.types.includes('country') && c.short_name === normalizedCountry
      );

      // Verify the returned postal code matches what the user typed (optional)
      const exactCodeMatch = topResult.address_components.find(
        c => c.types.includes('postal_code') && 
        c.long_name.replace(/\s/g, '') === postalCode.replace(/\s/g, '')
      );
      // console.log("isPostalType: ",isPostalType,
      //   "\n countryMatch: ",countryMatch,
      //   "\n exactCodeMatch: ",exactCodeMatch,
      //   "\n postalCode: ",postalCode,
      // )
      if (countryMatch && (isPostalType || exactCodeMatch)) {
        return true;
      }
    }
    return false;
  } catch (error) {
    console.error('Error validating postal code:', error);
    return isValidPostalString(postalCode); 
  }
};

export const findCountry = (selectedFactoryCountry, fromCountry, toCountry, isPickupMode, transaction_type) => {
  let country = selectedFactoryCountry;
  if(!country){
      country = isPickupMode ? (transaction_type === "Importer" ? (fromCountry) : toCountry) : 
      (transaction_type === "Importer" ? toCountry : fromCountry)
  }
  return country;
}
